export default __webpack_public_path__ + "static/media/about-4.14cad81b.jpg";